import React from "react";
import PropTypes from "prop-types";

import { Alert, Row, Col } from "antd";
import { css } from "glamor";

import Button from "@arachnys/styleguide/Button";
import SafeHTML from "@arachnys/styleguide/SafeHTML";
import Visible from "@arachnys/styleguide/Visible";

const styles = {
    sourceInformation: css({
        color: "rgba(0, 0, 0, 0.85)",
        fontSize: "1.125rem",
        fontWeight: "bold",
        lineHeight: 1.22,
    }),
    wrapper: css({
        marginBottom: "2rem",
    }),
    heading: css({
        fontWeight: "normal",
        marginBottom: 0,
    }),
    actions: css({
        textAlign: "right",
    }),
    button: css({
        marginLeft: ".5rem",
    }),
};

const TaskHeader = ({
    sourceInformation,
    title,
    userInstructions,
    canClaimTask,
    canUnassignTask,
    onAssign,
    onUnassign,
    entityRequestUlid,
}) => (
    <div className={`${styles.wrapper}`}>
        <Row className={`${styles.wrapper}`} type="flex" align="middle">
            <Col span={16}>
                {sourceInformation && (
                    <div
                        className={`${styles.sourceInformation}`}
                        data-test-id="source-information"
                    >
                        {sourceInformation}
                    </div>
                )}
                <h1 className={`${styles.heading}`}>{title}</h1>
            </Col>

            <Col className={`${styles.actions}`} span={8}>
                {entityRequestUlid && (
                    <Button.Primary
                        className={`${styles.button}`}
                        href={`/request-portal/tickets/${entityRequestUlid}/`}
                        target="_blank"
                    >
                        View Request
                    </Button.Primary>
                )}

                <Visible isVisible={canClaimTask}>
                    <Button.Secondary
                        className={`${styles.button}`}
                        data-testid="claimTask"
                        onClick={onAssign}
                        size="small"
                        reverse
                    >
                        Claim Task
                    </Button.Secondary>
                </Visible>

                <Visible isVisible={canUnassignTask}>
                    <Button.Secondary
                        className={`${styles.button}`}
                        data-testid="unassignTask"
                        onClick={onUnassign}
                        size="small"
                        reverse
                    >
                        Unassign Task
                    </Button.Secondary>
                </Visible>
            </Col>
        </Row>

        <Alert message={<SafeHTML html={userInstructions} />} type="info" />
    </div>
);

TaskHeader.propTypes = {
    sourceInformation: PropTypes.string,
    title: PropTypes.string.isRequired,
    userInstructions: PropTypes.string.isRequired,
    canClaimTask: PropTypes.bool.isRequired,
    canUnassignTask: PropTypes.bool.isRequired,
    onAssign: PropTypes.func.isRequired,
    onUnassign: PropTypes.func.isRequired,
    entityRequestUlid: PropTypes.string,
};

export default TaskHeader;
